import { RootState } from '..';

export const geofenceGeolocationSelector = (state: RootState) => state.geofence.geolocation;
export const geofenceContentInfoSelector = (state: RootState) => state.geofence.contentInfo;
export const isGeofenceModalOpenedSelector = (state: RootState) => state.geofence.isGeofenceModalOpened;
export const isContentNotAvailableSelector = (state: RootState) => state.geofence.isContentNotAvailable;
